import s from '../ContextMenuItems.module.scss';
import { TGetSessionFinishItem } from './interfaces';

export const getSessionFinishItem: TGetSessionFinishItem = ({
  t,
  permissions,
  openStopClientSessionModal,
  selectedHostsIds,
}) => {
  return !permissions?.has('client_session_manage')
    ? null
    : {
        key: 'session-finish',
        text: t('host.ctx.session.finish'),
        iconName: 'StopSessionIcon',
        className: s['red-text'],
        onClick: openStopClientSessionModal,
        disabled: ({ client_sessions: [activeSession], locked }) =>
          Boolean(!activeSession || (selectedHostsIds?.length ?? 0) > 1) ||
          locked,
        isLastInGroup: true,
      };
};
